import { handleRedirection } from './payment-redirection';
import { i18n } from '@/commons/utils';
import { isSecondaryBlockOpened } from '@/checkout/payment/payment';

export function Sofort() {
  this.init = function init(_params) {
    this.container = _params.container;
    this.parent = _params.parent;
    this.onExpressConfirmation = _params.onExpressConfirmation;

    this.state = {
      selected: _params.selected || false
    };

    this.props = {
      isExpress: _params.isExpress || false,
      isCheckout: _params.isCheckout || false,
      orderId: _params.orderId,
      multiEnabled: this.container.getAttribute('data-multi-enabled') === 'true',
      paymentTypeId: this.container.getAttribute('data-payment-type-id')
    };

    this.elements = {};
    if (this.props.isExpress === false) {
      this.elements.header = this.container.querySelector('.dkt-block-header');
      this.elements.content = this.container.querySelector('.dkt-block-content');
    } else {
      this.elements.content = this.container;
    }

    if (this.elements.content) {
      this.render();
    }

    this.events();
  };
}

Sofort.prototype.render = function render() {
  this.elements.content.innerHTML = `<p class="dkt-description">${i18n('payment.primary.description.SOFORT_-_BANKING')}</p>`;
};

Sofort.prototype.events = function events() {
  document.addEventListener('clickedOnPay', () => this.checkPayment());
  document.addEventListener('PrimaryPaymentBlockSelected', () => this.unselect());
  if (this.props.isCheckout === true) {
    this.elements.header.addEventListener('click', () => this.select());
  }
};

Sofort.prototype.select = function select(event) {
  if ((this.state.selected === false && event) || !event) {
    document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected', {
      bubbles: false,
      cancelable: false,
      detail: {
        'multiEnabled': this.props.multiEnabled
      }
    }));
    if (this.elements.content) {
      $(this.elements.content).slideDown('fast', () => this.displaySelect());
    } else {
      this.container.classList.add('dkt-block--selected');
    }
    this.state.selected = true;
    if (this.props.isExpress === false && this.parent.enableButton) {
      this.parent.enableButton();
    }
  }
};

Sofort.prototype.unselect = function unselect() {
  if (this.elements.content) {
    $(this.elements.content).slideUp('normal', () => this.displayUnselect());
  } else {
    this.displayUnselect();
  }
  this.state.selected = false;
};

Sofort.prototype.displaySelect = function displaySelect() {
  this.container.classList.add('dkt-block--selected');
  this.container.classList.add('dkt-block--open');
};

Sofort.prototype.displayUnselect = function displayUnselect() {
  this.container.classList.remove('dkt-block--selected');
  this.container.classList.remove('dkt-block--open');
};

Sofort.prototype.checkPayment = function checkPayment() {
  if (this.state.selected === true) {
    if (this.parent.checkTermsOfUse && this.parent.checkTermsOfUse() === false) {
      return;
    }

    if (this.props.isCheckout) {
      if (this.parent.checkBillingAddress && this.parent.checkBillingAddress() === false) {
        return;
      }
      if (this.parent.isFullSecondaryPayment && this.parent.isFullSecondaryPayment() === true) {
        return;
      }
    }
    this.submitPayment();
  }
};

Sofort.prototype.submitPayment = function submitPayment() {
  const params = {
    paymentTypeId: this.props.paymentTypeId,
    redirectionUrl: document.getElementById('redirectionUrl').value,
    pspRedirectionUrl: document.getElementById('pspRedirectionUrl').value,
    orderAttributes: JSON.stringify(this.parent.getAnalyticsInfos()),
    orderId: this.props.orderId,
    paymentUrl: document.getElementById('paymentUrl').value
  };

  params.useSecondaryMop = isSecondaryBlockOpened();

  if (this.parent.displayLoader) {
    this.parent.displayLoader();
  }

  cube.ajax.post('rest/model/com/decathlon/cube/commerce/payment/PaymentActor/applyPayment', params)
    .onSuccess(response => handleRedirection(this, response))
    .onError(response => this.submitPaymentError(response))
    .call();
};

Sofort.prototype.submitPaymentError = function submitPaymentError() {
  const { parent } = this;
  if (parent.hideLoader) {
    parent.hideLoader();
  }
  if (parent.displayError) {
    parent.displayError(i18n('TECH_0001'));
  }
};



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-sofort.js